import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';
import './SuccessPage.css';
import config from '../functions/config';


const SuccessPage = () => {
  const [userName, setUserName] = useState('User');
  const [books, setBooks] = useState([]);
  const [filteredBooks, setFilteredBooks] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const ID = Cookies.get('sessionid');
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  console.log('Session ID:', ID);

  useEffect(() => {
    fetchBooks();
  }, []);

  const fetchBooks = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/books/`);
      if (response.ok) {
        const data = await response.json();
        setBooks(data);
        setFilteredBooks(data);
      }
    } catch (error) {
      console.error('Error fetching books:', error);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = books.filter(
      (book) =>
        book.title.toLowerCase().includes(query) ||
        book.author.toLowerCase().includes(query) ||
        book.publisher.toLowerCase().includes(query) ||
        book.price.toString().includes(query)
    );
    setFilteredBooks(filtered);
  };

  return (
    <div className="success-page">
      {/* Navbar */}
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        {/* Brand Name */}
        <Link className="navbar-brand" to="/">
          📚 Library 
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Menu */}
        <div className={`navbar-collapse ${isOpen ? "show" : "collapse"}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/userhome">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/success">
                Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile">
                Profile
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/rentalhistory">
                Rented Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/purchasehistory">
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/login" className="btn btn-danger">
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

      {/* Welcome Message */}
      <div className="container my-4 mt-5 pt-5 text-center text-light">
        <h2 className="mb-3">Welcome, {userName}!</h2>
        <p>Discover our collection of books available for rent and purchase.</p>

        {/* Search Box */}
        <div className="search-box">
          <input
            type="text"
            className="form-control"
            placeholder="🔍 Search by name, price, author, or publisher..."
            value={searchQuery}
            onChange={handleSearch}
          />
        </div>

        {/* Books Cards */}
        <div className="row pt-5">
          {filteredBooks.map((book) => (
            <div className="col-md-4 mb-4" key={book.id}>
              <div className="card h-100 shadow-sm">
                <img
                  src={
                    book.image
                      ? `${config.BASE_URL}${book.image}`
                      : 'https://via.placeholder.com/150'
                  }
                  alt={book.title || 'No Image Available'}
                  className="card-img-top"
                  style={{ height: '200px', objectFit: 'cover' }}
                  onError={(e) => (e.target.src = 'https://via.placeholder.com/150')}
                />
                <div className="card-body">
                  <h5 className="card-title">{book.title}</h5>
                  <p className="card-text">
                    <strong>Author:</strong> {book.author}
                  </p>
                  <p className="card-text">
                    <strong>Publisher:</strong> {book.publisher}
                  </p>
                  <p className="card-text">
                    <strong>Price:</strong> Rs. {book.price}
                  </p>
                  <p>
                    <strong>Availability:</strong> {book.stock > 0 ? 'Available' : 'Not Available'}
                  </p>
                  <div className="d-flex justify-content-between">
                    <Link to={`/rent/${book.id}`} className="btn btn-primary">
                      Rent
                    </Link>
                    <Link to={`/buy/${book.id}`} className="btn btn-success">
                      Buy
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
